import { RoimaticService } from 'AppServices/roimaticService';
import { ApiService } from 'Features/bizgainOnboarding/services/apiService';
import {
  store
} from 'Store/store';
import { bizgainOnboardingRedirects, bizgainOnboardingRoutes, launchState, objectiveType, phoneNoOptions } from '../features/bizgainOnboarding/constants';
const { updateRoimaticCampaign } = new ApiService();
export default {
  methods: {
    async redirect(defaultParams, subsequentParams, toEdit = False, nextLaunchState, newBusinessDetails, newAdditionalConfig = null){
      let currentRoute = store.getters.currentRoute;
      let businessDetails = store.getters.businessDetails;
      let roimaticConfiguration = store.getters.roimaticConfiguration;
      let currentLaunchState = businessDetails.launchState;
      let nextRoute = '';
      let routeType = '';
      let isSubsequentLaunch = store.getters.isInAppCampaign;
      routeType = toEdit ? 'edit' : 'default';
      let params = isSubsequentLaunch ? subsequentParams : defaultParams;
      let isAgentFlow = null;
      isAgentFlow = localStorage.getItem('isAgentFlow');

      let businessPhoneNumber = store.getters.businessDetails.businessPhoneNumber;
      let email = store.getters.businessDetails.email//localStorage.getItem('email');//store.getters.signUpDetails.email;
      let signUpRequest = {
        email: email,
        phoneNumber: businessPhoneNumber,
        sessionId: store.getters.businessDetails.sessionId,
        portalDomain: store.getters.portalDomain,
        region: store.getters.region,
        otp: null,
        password: store.getters.businessDetails.password
      }
      let isAfterBudget = nextLaunchState >= launchState.ADACCOUNTSETUPANIMATION;

      //redirect for shorten flow
      if((businessDetails && businessDetails.shortenFlow) || (roimaticConfiguration && roimaticConfiguration.shortenFlow)){
        if(((currentRoute === bizgainOnboardingRoutes.CreativeDetailsV2.name) || (currentRoute === bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.name) || (currentRoute == bizgainOnboardingRoutes.SetupBusinessInfo.name)) && typeof(toEdit) === 'number'){
          //redirect from creativeDetails page in shorten flow to image creative edit page
          if(toEdit === 1){
            routeType = 'imageCreativesCreativeEdit';
            nextLaunchState = launchState.CREATIVESEDIT;
          }
          //redirect from creativeDetails page in shorten flow to image creative ad details edit page
          else if(toEdit === 2){
            routeType = 'imageCreativesAdDetailsEdit';
            nextLaunchState = launchState.FACEBOOKADEDIT;
          }
          //redirect from creativeDetails page in shorten flow to google edit page
          else if(toEdit === 3){
            routeType = 'googleAdsEdit'
            nextLaunchState = launchState.GOOGLEADEDIT
          }
        }
        if (((currentRoute == bizgainOnboardingRoutes.ImageCreativesAdDetailsEdit.name) ||
        (currentRoute == bizgainOnboardingRoutes.GoogleAdsEdit.name) ||
        (currentRoute == bizgainOnboardingRoutes.ImageCreativesCreativeEdit.name) ||
        (currentRoute == bizgainOnboardingRoutes.SubsequentImageCreativesAdDetailsEdit.name) ||
        (currentRoute == bizgainOnboardingRoutes.SubsequentGoogleAdsEdit.name) ||
        (currentRoute == bizgainOnboardingRoutes.SubsequentImageCreativesCreativeEdit.name)
        // (currentRoute == bizgainOnboardingRoutes.SubsequentBudget.name) ||
        // (currentRoute == bizgainOnboardingRoutes.AdAccountSetupAnimation.name)
        )){
          routeType = store && store.getters && store.getters.isAutoGeneratedFlow ? 'autoGeneratedFlow' : 'shortenFlow'
        }
        if(((currentRoute == bizgainOnboardingRoutes.CreativeDetailsV2.name) || (currentRoute == bizgainOnboardingRoutes.SubsequentCreativeDetailsV2.name) || (currentRoute == bizgainOnboardingRoutes.SetupBusinessInfo.name)) && !toEdit){
          if((isSubsequentLaunch)){
            routeType = 'default';
            nextLaunchState = launchState.BUDGET;
          }
          else if(businessPhoneNumber || email){
            store.dispatch('setSignUpRequest', signUpRequest);
            routeType = 'authSkip';
            nextLaunchState = launchState.BUDGET;
          }
          else if((store.getters.regionConfig.PhoneNoOptions ===  phoneNoOptions.optional)) {
            routeType = 'PhoneNoOptional';
            nextLaunchState = launchState.BUSINESSPHONENUMBER;
          }
          else if((store.getters.regionConfig.PhoneNoOptions ===  phoneNoOptions.required)){
            routeType = 'PhoneNoRequired';
            nextLaunchState = launchState.BUSINESSPHONENUMBER;
          }
          else{
            routeType = 'default';
            nextLaunchState = launchState.SIGNUP;
          }
        }
        if(currentRoute == bizgainOnboardingRoutes.BusinessPhoneNumber.name){
          routeType = 'shortenFlow';
          nextLaunchState = launchState.BUDGET;
        }
        if(currentRoute == bizgainOnboardingRoutes.EmailSignup.name){
          routeType = 'shortenFlow';
          nextLaunchState = launchState.BUDGET;
        }
        if(currentRoute == bizgainOnboardingRoutes.ChannelSelection.name){
          routeType = 'shortenFlow';
          nextLaunchState = launchState.TARGETINGV2;
        }
      }

      if((currentRoute == bizgainOnboardingRoutes.GoogleAds.name || currentRoute == bizgainOnboardingRoutes.SubsequentGoogleAds.name) && routeType == 'default'){
        if(isAgentFlow){
          routeType = 'agentFlow'
        }
        else if (!isAgentFlow && store.getters.businessDetails && store.getters.businessDetails.businessPhoneNumber){
          routeType = 'PhoneNoRequiredFlow'
        }
        else{
          routeType = 'default'
        }
      }
      if((currentRoute == bizgainOnboardingRoutes.ImageCreativesAdPreview.name || currentRoute == bizgainOnboardingRoutes.SubsequentImageCreativesAdPreview.name) && routeType == 'default'){
        let objective = store.getters.objective;
        if(objective === objectiveType.instantMessages.id){
          if(isAgentFlow){
            routeType = 'agentFlowNext'
          }
          else if (!isAgentFlow && store.getters.signUpRequest && store.getters.businessDetails.businessPhoneNumber){
            routeType = 'PhoneNoRequiredFlow'
          }
          else {
            routeType = 'defaultNext';
          }
        }else {
          routeType = 'default';
        }

        switch(routeType){
          case 'agentFlowNext':
            if(bizgainOnboardingRedirects[currentRoute]['agentFlowNextLaunchState'])
            {
              nextLaunchState = bizgainOnboardingRedirects[currentRoute]['agentFlowNextLaunchState'];
            }
            break;
          case 'defaultNext':
            if(bizgainOnboardingRedirects[currentRoute]['defaultNextLaunchState'])
            {
              nextLaunchState = bizgainOnboardingRedirects[currentRoute]['defaultNextLaunchState'];
            }
            break;
          case 'PhoneNoRequiredFlow':
            if(bizgainOnboardingRedirects[currentRoute]['PhoneNoRequiredFlowLaunchState'])
            {
              nextLaunchState = bizgainOnboardingRedirects[currentRoute]['PhoneNoRequiredFlowLaunchState'];
            }
            break;
        }
      }
      if (isAgentFlow){
        if (currentLaunchState >= 1700 && isAgentFlow && businessDetails.targeting && businessDetails.targeting.location){
          // if nextLaunchState is greater than or equal to 1700 i.e., targeting, complete signup, then redirect to summary
          if(params.fromSummary){
            nextRoute = bizgainOnboardingRoutes.Summary.name;
          }
          else{
            nextRoute = bizgainOnboardingRedirects[currentRoute]['agentFlow'] ? bizgainOnboardingRedirects[currentRoute]['agentFlow'] : bizgainOnboardingRedirects[currentRoute][routeType];
            nextLaunchState = bizgainOnboardingRedirects[currentRoute]['agentFlowLaunchState'] ? bizgainOnboardingRedirects[currentRoute]['agentFlowLaunchState'] : nextLaunchState;
          }
          if ((currentRoute == bizgainOnboardingRoutes.EmailSignup.name && email) || currentRoute == bizgainOnboardingRoutes.CreativeAnimation.name){
            nextRoute = bizgainOnboardingRedirects[currentRoute]['agentFlow'] ? bizgainOnboardingRedirects[currentRoute]['agentFlow'] : bizgainOnboardingRedirects[currentRoute][routeType];
          }
        }
        else {
          /* if incomplete signup, then this is agent doing the signup
                  So for each step check if there is a custom step defined for agent flow?
                  if yes, then redirect to that else redirect to the default step
              */
          if(toEdit){
            nextRoute = bizgainOnboardingRedirects[currentRoute][routeType];
          }
          else{
            nextRoute = bizgainOnboardingRedirects[currentRoute]['agentFlow'] ? bizgainOnboardingRedirects[currentRoute]['agentFlow'] : bizgainOnboardingRedirects[currentRoute][routeType];
            nextLaunchState = bizgainOnboardingRedirects[currentRoute]['agentFlowLaunchState'] ? bizgainOnboardingRedirects[currentRoute]['agentFlowLaunchState'] : nextLaunchState;
          }
        }
      } else{
        // if its not agent flow, then redirect to next step based of whether this is subsequentLaunch or not
        nextRoute = bizgainOnboardingRedirects[currentRoute][routeType];
      }
      // Logic to skip email and phone number steps or any other?
      if (isAgentFlow){
        if(nextRoute == bizgainOnboardingRoutes.EmailSignup.name){
          nextRoute = isAgentFlow ? bizgainOnboardingRedirects[bizgainOnboardingRoutes.EmailSignup.name]['agentFlow'] : bizgainOnboardingRedirects[bizgainOnboardingRoutes.EmailSignup.name]['default'];
          nextLaunchState = isAgentFlow ? bizgainOnboardingRedirects[bizgainOnboardingRoutes.EmailSignup.name]['agentFlowLaunchState'] : nextLaunchState;
        }
      }
      if (businessPhoneNumber || isAgentFlow){
        if(nextRoute == bizgainOnboardingRoutes.BusinessPhoneNumber.name){
          nextRoute = bizgainOnboardingRedirects[bizgainOnboardingRoutes.SelectObjective.name][routeType];
          nextLaunchState = launchState.OBJECTIVE;
        }
      }
      if(isAgentFlow){
        if(currentRoute == bizgainOnboardingRoutes.Summary.name){
          if(email || businessPhoneNumber){
            store.dispatch('setSignUpRequest', signUpRequest);
            nextRoute = bizgainOnboardingRedirects.summary.agentFlow;
          }
          else if(!businessPhoneNumber && (store.getters.regionConfig.PhoneNoOptions ===  phoneNoOptions.required || store.getters.regionConfig.PhoneNoOptions ===  phoneNoOptions.optional)){
            nextRoute = bizgainOnboardingRoutes.BusinessPhoneNumber.name;
          }
          else{
            nextRoute = bizgainOnboardingRoutes.EmailSignup.name
          }
        }
        else if(currentRoute == bizgainOnboardingRoutes.BusinessPhoneNumber.name){
          if(businessPhoneNumber){
            store.dispatch('setSignUpRequest', signUpRequest);
            nextRoute = bizgainOnboardingRoutes.CreativeAnimation.name;;
          }
          if(!businessPhoneNumber && (store.getters.regionConfig.PhoneNoOptions ===  phoneNoOptions.optional)){
            nextRoute = bizgainOnboardingRoutes.EmailSignup.name;
          }
        }
        else if(currentRoute == bizgainOnboardingRoutes.EmailSignup.name){
          store.dispatch('setSignUpRequest', signUpRequest);
          nextRoute = bizgainOnboardingRoutes.CreativeAnimation.name;;
        }
      }
      if (currentRoute == bizgainOnboardingRoutes.BusinessLocationDetails.name && !isAgentFlow){
        if(store.getters.businessDetails.businessPhoneNumber){
          nextRoute = bizgainOnboardingRoutes.SelectObjective.name;
          nextLaunchState = launchState.OBJECTIVE;
        }
        else{
          if(store.getters.regionConfig.PhoneNoOptions ===  phoneNoOptions.required){
            nextRoute = bizgainOnboardingRoutes.BusinessPhoneNumber.name;
            nextLaunchState = launchState.businessPhoneNumber;
          }
          else if(store.getters.regionConfig.PhoneNoOptions ===  phoneNoOptions.Disabled){
            nextRoute = bizgainOnboardingRoutes.SelectObjective.name;
            nextLaunchState = launchState.OBJECTIVE;
          }
          else if(store.getters.regionConfig.PhoneNoOptions ===  phoneNoOptions.optional){
            nextRoute = bizgainOnboardingRoutes.BusinessPhoneNumber.name;
            nextLaunchState = launchState.businessPhoneNumber;
          }
        }
      }
      if(newBusinessDetails){
        if(nextLaunchState && nextRoute != bizgainOnboardingRoutes.Summary.name){
          newBusinessDetails.launchState = nextLaunchState;
        }
        let payload = {
          sessionId: businessDetails.sessionId,
          oldBusinessDetails: businessDetails,
          newBusinessDetails: newBusinessDetails
        };
        await store.dispatch('patchBusinessDetails', payload);
      }
      if(!store.getters.isError){
        if(currentRoute == bizgainOnboardingRoutes.ExtractOfferDetails.name || currentRoute == bizgainOnboardingRoutes.SubsequentExtractOfferDetails.name){
          store.dispatch('clearCreativeImages');
          store.dispatch('getBusinessDetails', { sessionId: businessDetails.sessionId });
        }
        if(currentRoute == bizgainOnboardingRoutes.SelectObjective.name ||
          currentRoute == bizgainOnboardingRoutes.SubsequentSelectObjective.name ||
          currentRoute == bizgainOnboardingRoutes.BusinessDetailsV2.name  ||
          currentRoute == bizgainOnboardingRoutes.SubsequentBusinessDetailsV2.name
        ){//check in sebsequentLaunch
          store.dispatch('addCreativeLogo', {});
          store.dispatch('addCreativeLeadImage', []);
        }
        if(isSubsequentLaunch
         && currentRoute != (bizgainOnboardingRoutes.SubsequentAgeGenderTarget.name) &&
         currentRoute != (bizgainOnboardingRoutes.SubsequentLocationTargeting.name) && currentRoute != bizgainOnboardingRoutes.TargetingV2.name
         && !isAfterBudget && currentRoute != bizgainOnboardingRoutes.SubsequentBudget.name && currentRoute != bizgainOnboardingRoutes.Budget.name){
          await updateRoimaticCampaign(store.getters.businessProfileId, store.getters.roimaticCampaignId, businessDetails.sessionId);
          if(currentRoute == bizgainOnboardingRoutes.SelectObjective.name || currentRoute == bizgainOnboardingRoutes.SubsequentSelectObjective.name){
            if(businessDetails.creativeDetail.objective == objectiveType.calls.id)
            {
              let roimaticService = new RoimaticService(this.businessProfileId);
              let roimaticConfiguration = store.getters.roimaticConfiguration;
              let newRoimaticConfig = JSON.parse(JSON.stringify(roimaticConfiguration));
              newRoimaticConfig.business.contactDetails.phone = businessDetails.mobileNumber;
              await roimaticService.updateConfiguration(
                roimaticConfiguration,
                newRoimaticConfig
              );
            }
          }
        }
        if(isSubsequentLaunch && (currentRoute == bizgainOnboardingRoutes.SubsequentAgeGenderTarget.name || currentRoute == bizgainOnboardingRoutes.SubsequentLocationTargeting.name) && currentRoute != bizgainOnboardingRoutes.SubsequentBudget.name){
          let additionalConfiguration = store.getters.additionalConfiguration;
          let businessProfileId = store.getters.businessProfileId;
          let roimaticCampaignId = store.getters.roimaticCampaignId;
          if (newAdditionalConfig && newAdditionalConfig.localBusiness) {
            newAdditionalConfig.localBusiness.launchState = nextLaunchState;
            let payload = {
              businessProfileId: businessProfileId,
              campaignId: roimaticCampaignId,
              oldAddtionalConfig: additionalConfiguration,
              newAddtionalConfig: newAdditionalConfig
            }
            await store.dispatch('patchAdditionalConfiguration', payload);
          }
        }
        if(!store.getters.isError && !store.getters.isErrorAddtioanlConfig){
          this.$router.push({ name: nextRoute, params: params });
        }
      }
    }
  }
}
